<template>
    <div 
      v-if="visible" 
      class="toast" 
      :class="{ 'toast-success': type === 'success', 'toast-error': type === 'error' }"
      @click="hideToast"
    >
      <div class="toast-content">
        <i :class="iconClass"></i>
        <span>{{ message }}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ToastShow',
    data() {
      return {
        visible: false,
        message: '',
        type: 'info', // success/error/info/warning
        timer: null
      };
    },
    computed: {
      iconClass() {
        const icons = {
          success: 'fa fa-check-circle',
          error: 'fa fa-times-circle',
          info: 'fa fa-info-circle',
          warning: 'fa fa-exclamation-circle'
        };
        return icons[this.type] || icons.info;
      }
    },
    methods: {
      show(options) {
        // 合并配置
        if (typeof options === 'string') {
          this.message = options;
          this.type = 'info';
        } else {
          this.message = options.message || '';
          this.type = options.type || 'info';
        }
        
        // 显示提示
        this.visible = true;
        
        // 自动关闭
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.hideToast();
        }, options.duration || 3000);
      },
      hideToast() {
        this.visible = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 15px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    cursor: pointer;
    transition: opacity 0.3s, transform 0.3s;
  }
  
  .toast-content {
    display: flex;
    align-items: center;
  }
  
  .toast i {
    margin-right: 8px;
    font-size: 16px;
  }
  
  .toast-success {
    background-color: #52c41a;
    color: white;
  }
  
  .toast-error {
    background-color: #ff4d4f;
    color: white;
  }
  </style>